import type { Environment } from '@/react/portainer/environments/types';
import type { EnvironmentGroup } from '@/react/portainer/environments/environment-groups/types';

import { Widget, WidgetBody } from '@@/Widget';
import { Button } from '@@/buttons';
import { StickyFooter } from '@@/StickyFooter/StickyFooter';

import {
  PolicyType,
  EnvironmentTypeFilter,
  CategoryFilter,
  PolicyTemplate,
} from '../types';
import { PolicyTypeSelector } from '../components/PolicyTypeSelector/PolicyTypeSelector';

/* --- Step 1: Type Selection --- */
type PolicyTypeSelectionStepProps = {
  value: PolicyType | null;
  onChange: (type: PolicyType) => void;
  onTemplateSelect?: (template: PolicyTemplate | null) => void;
  selectedTemplateId?: string | null;
  environments: Environment[];
  groups: EnvironmentGroup[];
  /** When above 100, compatible groups count is not shown in policy type selector. */
  totalEnvironmentCount?: number;
  environmentFilter: EnvironmentTypeFilter;
  onEnvironmentFilterChange: (v: EnvironmentTypeFilter) => void;
  categoryFilter: CategoryFilter;
  onCategoryFilterChange: (v: CategoryFilter) => void;
  searchQuery: string;
  onSearchQueryChange: (v: string) => void;
  onNext: () => void;
};

export function PolicyTypeSelectionStep({
  value,
  onChange,
  onTemplateSelect,
  selectedTemplateId,
  environments,
  groups,
  totalEnvironmentCount,
  environmentFilter,
  onEnvironmentFilterChange,
  categoryFilter,
  onCategoryFilterChange,
  searchQuery,
  onSearchQueryChange,
  onNext,
}: PolicyTypeSelectionStepProps) {
  return (
    <>
      <div className="row">
        <div className="col-sm-12">
          <Widget>
            <WidgetBody>
              <PolicyTypeSelector
                value={value}
                onChange={onChange}
                onTemplateSelect={onTemplateSelect}
                selectedTemplateId={selectedTemplateId}
                environments={environments}
                groups={groups}
                totalEnvironmentCount={totalEnvironmentCount}
                environmentFilter={environmentFilter}
                onEnvironmentFilterChange={onEnvironmentFilterChange}
                categoryFilter={categoryFilter}
                onCategoryFilterChange={onCategoryFilterChange}
                searchQuery={searchQuery}
                onSearchQueryChange={onSearchQueryChange}
              />
            </WidgetBody>
          </Widget>
        </div>
      </div>

      {/* Footer outside Widget with StickyFooter - matches create mode pattern */}
      <StickyFooter className="justify-end gap-4">
        <Button
          color="primary"
          onClick={onNext}
          disabled={!value}
          data-cy="policy-type-continue-button"
          size="medium"
        >
          Continue
        </Button>
      </StickyFooter>
    </>
  );
}
